/**
 * SiteContext — provides the current site id to editor widgets.
 *
 * Widgets render deep inside the grid/xyflow tree and receive only
 * WidgetProps (no siteId). ImageWidget needs the site id to POST uploads
 * to the right asset endpoint; without this the upload silently no-ops.
 * SiteDetail wraps the editor in <SiteProvider siteId={site.id}>.
 */
import { createContext, useContext, type PropsWithChildren } from "react";

const SiteIdContext = createContext<string | null>(null);

export function SiteProvider({
  siteId,
  children,
}: PropsWithChildren<{ siteId: string }>) {
  return (
    <SiteIdContext.Provider value={siteId}>{children}</SiteIdContext.Provider>
  );
}

/** Current site id, or null if rendered outside a SiteProvider. */
export function useSiteId(): string | null {
  return useContext(SiteIdContext);
}
